<template>
  <Modal
    :show="true"
    centered
    size="xxl"
    title="Endosado"
    @hide="$emit('hide')"
  >
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <ValidationObserver ref="form" class="form-row">
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label"
              >Servicio <span class="text-danger">*</span></label
            >
            <InputSelect
              v-model="form.servicio"
              label="nombre"
              :options="containers.servicios"
              name="Servicio"
              rules="required"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label"
              >Fecha <span class="text-danger">*</span></label
            >
            <InputDatepicker
              v-model="form.fecha"
              input-class="form-control form-control-sm"
              name="Fecha"
              rules="required"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label"
              >Idioma <span class="text-danger">*</span></label
            >
            <InputSelect
              v-model="form.idioma"
              label="nombre"
              :options="containers.idiomas"
              name="Idioma"
              rules="required"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">File</label>
            <InputText v-model="form.file" />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Hora Recojo</label>
            <InputText
              v-model="form.horaRecojo"
              name="Hora Recojo"
              rules="time"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Hora Inicio</label>
            <InputText
              v-model="form.horaInicio"
              name="Hora Inicio"
              rules="time"
            />
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-lg">
          <div class="form-group">
            <label for="" class="form-label"
              >Nombre Pax <span class="text-danger">*</span></label
            >
            <InputText
              v-model="form.nombre"
              name="Nombre Pax"
              rules="required"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label"
              >PAX <span class="text-danger">*</span></label
            >
            <InputText v-model="form.PAX" name="PAX" rules="required|numeric" />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">CHD</label>
            <InputText v-model="form.CHD" name="CHD" rules="numeric" />
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-lg-6">
          <label for="" class="form-label d-block">Tren Ida</label>
          <div class="form-row">
            <div class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label">Servicio</label>
                <InputSelect
                  v-model="form.trenIda.servicio"
                  label="servicio"
                  :options="trenIda.servicios"
                />
              </div>
            </div>
            <div v-if="trenIda.numeros.length" class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label"
                  >Número Tren <span class="text-danger">*</span></label
                >
                <InputSelect
                  v-model="form.trenIda.numero"
                  label="nroTren"
                  :options="trenIda.numeros"
                  name="Número Tren"
                  rules="required"
                />
              </div>
            </div>
            <div v-if="trenIda.horarios.length" class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label"
                  >Horario <span class="text-danger">*</span></label
                >
                <InputSelect
                  v-model="form.trenIda.horario"
                  label="opciones"
                  :options="trenIda.horarios"
                  name="Horario"
                  rules="required"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <label for="" class="form-label d-block">Tren Retorno</label>
          <div class="form-row">
            <div class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label">Servicio</label>
                <InputSelect
                  v-model="form.trenRetorno.servicio"
                  label="servicio"
                  :options="trenRetorno.servicios"
                />
              </div>
            </div>
            <div v-if="trenRetorno.numeros.length" class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label"
                  >Número Tren <span class="text-danger">*</span></label
                >
                <InputSelect
                  v-model="form.trenRetorno.numero"
                  label="nroTren"
                  :options="trenRetorno.numeros"
                  name="Número Tren"
                  rules="required"
                />
              </div>
            </div>
            <div v-if="trenRetorno.horarios.length" class="col-lg-4">
              <div class="form-group">
                <label for="" class="form-label"
                  >Horario <span class="text-danger">*</span></label
                >
                <InputSelect
                  v-model="form.trenRetorno.horario"
                  label="opciones"
                  :options="trenRetorno.horarios"
                  name="Horario"
                  rules="required"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Hotel</label>
            <InputSelect
              v-model="form.hotel"
              label="nombre"
              :options="containers.hoteles"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label"
              >Agencia <span class="text-danger">*</span></label
            >
            <InputSelect
              v-model="form.agencia"
              label="nombre"
              :options="containers.agencias"
              name="Agencia"
              rules="required"
            />
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Vehículo</label>
            <InputSelect
              v-model="form.vehiculo"
              label="vehiculo"
              :options="containers.vehiculos"
            />
          </div>
        </div>
        <div v-if="showOtroVehiculo" class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Otro Vehículo</label>
            <InputText v-model="form.otroVehiculo" />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Conductor</label>
            <InputSelect
              v-model="form.conductor"
              label="nombreCompleto"
              :options="containers.conductores"
            />
          </div>
        </div>
        <div v-if="showOtroConductor" class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Otro Conductor</label>
            <InputText v-model="form.otroConductor" />
          </div>
        </div>
        <div class="w-100"></div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Guía</label>
            <InputSelect
              v-model="form.guia"
              label="nombre"
              :options="containers.guias"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="" class="form-label">Transfer</label>
            <InputSelect
              v-model="form.transfer"
              label="nombre"
              :options="containers.transfers"
            />
          </div>
        </div>
        <div class="col-lg">
          <div class="form-group">
            <label for="" class="form-label">Observaciones</label>
            <InputTextArea v-model="form.observaciones" :maxHeight="52" />
          </div>
        </div>
        <template v-if="showMachuPicchuOpciones">
          <div v-if="loading.machuPicchu" class="w-100">
            <Spinner class="py-2"></Spinner>
          </div>
          <template v-else>
            <div class="w-100"></div>
            <div class="col-12">
              <h5>Guiado Machu Picchu</h5>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="" class="form-label">Tipo</label>
                <InputSelect
                  v-model="form.machuPicchu.tipo"
                  label="nombre"
                  :options="containers.tipos"
                />
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="" class="form-label">Hora Ticket</label>
                <InputText
                  v-model="form.machuPicchu.horaTicket"
                  name="Hora Ticket"
                  rules="time"
                />
              </div>
            </div>
            <div class="col-lg">
              <div class="form-group">
                <label for="" class="form-label">Almuerzo</label>
                <div class="d-flex align-items-center">
                  <div>
                    <InputCheckbox
                      v-model="form.machuPicchu.almuerzo"
                      type="checkbox"
                      :noLabel="true"
                    />
                  </div>
                  <div v-if="form.machuPicchu.almuerzo" class="ml-1 flex-fill">
                    <InputSelect
                      v-model="form.machuPicchu.restaurante"
                      label="nombre"
                      :options="containers.restaurantes"
                      name="Almuerzo"
                      rules="required"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg">
              <div class="form-group">
                <label for="" class="form-label">Overnight</label>
                <div class="d-flex align-items-center">
                  <div>
                    <InputCheckbox
                      v-model="form.machuPicchu.overnight"
                      type="checkbox"
                      :noLabel="true"
                    />
                  </div>
                  <div v-if="form.machuPicchu.overnight" class="ml-1 flex-fill">
                    <InputSelect
                      v-model="form.machuPicchu.hotel"
                      label="nombre"
                      :options="containers.hoteles"
                      name="Overnight"
                      rules="required"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg">
              <div class="form-group">
                <label for="" class="form-label">Huayna Picchu</label>
                <div class="d-flex align-items-center">
                  <div>
                    <InputCheckbox
                      v-model="form.machuPicchu.huaynaPicchu"
                      type="checkbox"
                      :noLabel="true"
                    />
                  </div>
                  <div
                    v-if="form.machuPicchu.huaynaPicchu"
                    class="ml-1 flex-fill"
                  >
                    <InputText
                      v-model="form.machuPicchu.huaynaPicchuHora"
                      name="Huayna Picchu"
                      rules="required|time"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-if="showTrasladosOpciones">
          <div class="w-100"></div>
          <div class="col-12">
            <h5>Traslados</h5>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Origen</label>
              <InputSelect
                v-model="form.traslado.origen"
                label="nombre"
                :options="containers.puntos"
              />
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">Destino</label>
              <InputSelect
                v-model="form.traslado.destino"
                label="nombre"
                :options="containers.puntos"
              />
            </div>
          </div>
        </template>
      </ValidationObserver>
      <div class="form-group text-right">
        <Button @click="onSave" :disabled="loading.save">Guardar</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Button from "../../shared/components/Button.vue";
import InputTextArea from "../../shared/components/InputTextArea.vue";
import InputCheckbox from "../../shared/components/InputCheckbox.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputText from "../../shared/components/InputText.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";

export default {
  components: {
    Modal,
    Spinner,
    InputText,
    InputSelect,
    InputDatepicker,
    InputCheckbox,
    InputTextArea,
    Button
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    modalItem: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      form: {
        servicio: null,
        fecha: "",
        idioma: null,
        file: "",
        horaRecojo: "",
        horaInicio: "",
        nombre: "",
        PAX: "",
        CHD: "",
        trenIda: {
          servicio: null,
          numero: null,
          horario: null
        },
        trenRetorno: {
          servicio: null,
          numero: null,
          horario: null
        },
        hotel: null,
        agencia: null,
        vehiculo: null,
        otroVehiculo: "",
        conductor: null,
        otroConductor: "",
        guia: null,
        transfer: null,
        observaciones: "",
        machuPicchu: {
          tipo: null,
          horaTicket: "",
          almuerzo: false,
          restaurante: null,
          overnight: false,
          hotel: null,
          huaynaPicchu: false,
          huaynaPicchuHora: ""
        },
        traslado: {
          origen: null,
          destino: null
        }
      },
      loading: {
        view: true,
        machuPicchu: true,
        save: false
      },
      containers: {
        agencias: [],
        conductores: [],
        guias: [],
        hoteles: [],
        idiomas: [],
        servicios: [],
        transfers: [],
        trenes: [],
        vehiculos: [],
        restaurantes: [],
        puntos: [],
        tipos: []
      }
    };
  },
  computed: {
    showMachuPicchuOpciones() {
      return this.form.servicio?.idServicio == 5 || false;
    },
    showTrasladosOpciones() {
      return this.form.servicio?.idServicio == 6 || false;
    },
    showOtroVehiculo() {
      return this.form.vehiculo?.idVehiculo == 0 || false;
    },
    showOtroConductor() {
      return this.form.conductor?.idPersona == 0 || false;
    },
    trenIda() {
      let trenesIn = this.containers.trenes.filter(item => item.tipo == 1);
      let servicios = {};
      let numeros = [];
      let horarios = [];

      // servicios
      trenesIn.forEach(item => {
        if (!servicios[item.idTrenServicio]) {
          servicios[item.idTrenServicio] = item;
        }
      });

      servicios = Object.values(servicios);

      // números
      if (this.form.trenIda.servicio) {
        numeros = {};
        const result = trenesIn.filter(
          item =>
            item.idTrenServicio == this.form.trenIda.servicio.idTrenServicio
        );
        result.forEach(item => {
          if (!numeros[item.idTren]) {
            numeros[item.idTren] = item;
          }
        });

        numeros = Object.values(numeros);
        numeros = numeros.sort((a, b) => a.nroTren - b.nroTren);
      }

      // horarios
      if (this.form.trenIda.numero) {
        horarios = this.containers.trenes.filter(
          item => item.idTren == this.form.trenIda.numero.idTren
        );
      }

      return {
        servicios,
        numeros,
        horarios
      };
    },
    trenRetorno() {
      let trenesIn = this.containers.trenes.filter(item => item.tipo == 2);
      let servicios = {};
      let numeros = [];
      let horarios = [];

      // servicios
      trenesIn.forEach(item => {
        if (!servicios[item.idTrenServicio]) {
          servicios[item.idTrenServicio] = item;
        }
      });

      servicios = Object.values(servicios);

      // números
      if (this.form.trenRetorno.servicio) {
        numeros = {};
        const result = trenesIn.filter(
          item =>
            item.idTrenServicio == this.form.trenRetorno.servicio.idTrenServicio
        );
        result.forEach(item => {
          if (!numeros[item.idTren]) {
            numeros[item.idTren] = item;
          }
        });

        numeros = Object.values(numeros);
        numeros = numeros.sort((a, b) => a.nroTren - b.nroTren);
      }

      // horarios
      if (this.form.trenRetorno.numero) {
        horarios = this.containers.trenes.filter(
          item => item.idTren == this.form.trenRetorno.numero.idTren
        );
      }

      return {
        servicios,
        numeros,
        horarios
      };
    }
  },

  async created() {
    let vm = this;
    let response;

    try {
      response = await vm.axios.get(`/endoses/nuevo`);
    } catch (error) {
      return;
    }

    vm.containers.agencias = response.data.content.agencias;

    vm.containers.guias = response.data.content.guias;
    vm.containers.hoteles = response.data.content.hoteles;
    vm.containers.idiomas = response.data.content.idiomas;
    vm.containers.servicios = response.data.content.servicios;
    vm.containers.transfers = response.data.content.transfers;
    vm.containers.trenes = response.data.content.trenes;
    vm.containers.restaurantes = response.data.content.restaurantes;
    vm.containers.puntos = response.data.content.puntos;

    const vehiculos = response.data.content.vehiculos;

    vehiculos.unshift({
      idVehiculo: 0,
      vehiculo: "OTRO"
    });

    vm.containers.vehiculos = response.data.content.vehiculos;

    const conductores = response.data.content.conductores;

    conductores.unshift({
      idPersona: 0,
      nombreCompleto: "OTRO"
    });

    vm.containers.conductores = conductores;

    if (vm.modalItem) {
      vm.form.servicio = vm.containers.servicios.find(
        item => item.idServicio == vm.modalItem.idServicio
      );
      vm.form.fecha = vm.modalItem.fecha;
      vm.form.idioma = vm.containers.idiomas.find(
        item => item.idIdioma == vm.modalItem.idIdioma
      );
      vm.form.file = ["", "null", null].includes(vm.modalItem.file)
        ? ""
        : vm.modalItem.file;
      vm.form.horaRecojo = vm.$options.filters.date(
        vm.modalItem.horaRecojo,
        "HH:mm:ss",
        "HH:mm"
      );
      vm.form.horaInicio = vm.$options.filters.date(
        vm.modalItem.horaInicio,
        "HH:mm:ss",
        "HH:mm"
      );
      vm.form.nombre = vm.modalItem.pasajero;
      vm.form.PAX = vm.modalItem.nroAdultos;
      vm.form.CHD = vm.modalItem.nroNinos || "";
      vm.form.hotel = vm.modalItem.idHotel
        ? vm.containers.hoteles.find(
            item => item.idHotel == vm.modalItem.idHotel
          )
        : null;
      vm.form.agencia = vm.containers.agencias.find(
        item => item.idAgencia == vm.modalItem.idAgencia
      );

      // if (vm.modalItem.otroVehiculo) {
      //   vm.form.vehiculo = vm.containers.vehiculos[0];
      //   vm.form.otroVehiculo = vm.modalItem.otroVehiculo;
      // } else {
      //   vm.form.vehiculo = vm.modalItem.idConductor
      //     ? vm.containers.vehiculos.find(
      //         item => item.idVehiculo == vm.modalItem.idConductor
      //       )
      //     : null;
      // }

      if (vm.modalItem.otroVehiculo) {
        vm.form.vehiculo = vm.containers.vehiculos[0];
        vm.form.otroVehiculo = vm.modalItem.otroVehiculo;
      } else {
        if (vm.modalItem.idVehiculo) {
          vm.form.vehiculo = vm.containers.vehiculos.find(
            item => item.idVehiculo == vm.modalItem.idVehiculo
          );
        }
      }

      if (vm.modalItem.otroConductor) {
        vm.form.conductor = vm.containers.conductores[0];
        vm.form.otroConductor = vm.modalItem.otroConductor;
      } else {
        if (vm.modalItem.idConductor) {
          vm.form.conductor = vm.containers.conductores.find(
            item => item.idPersona == vm.modalItem.idConductor
          );
        }
      }

      vm.form.guia = vm.modalItem.idGuia
        ? vm.containers.guias.find(
            item => item.idPersona == vm.modalItem.idGuia
          )
        : null;
      vm.form.transfer = vm.modalItem.idTransfer
        ? vm.containers.transfers.find(
            item => item.idPersona == vm.modalItem.idTransfer
          )
        : null;
      vm.form.observaciones = vm.modalItem.observaciones || "";

      // tren ida
      vm.form.trenIda.servicio = vm.modalItem.idTrenServicioIn
        ? vm.containers.trenes.find(
            item =>
              item.idTrenServicio == vm.modalItem.idTrenServicioIn &&
              item.tipo == 1
          )
        : null;
      vm.form.trenIda.numero = vm.modalItem.idTrenIn
        ? vm.containers.trenes.find(
            item => item.idTren == vm.modalItem.idTrenIn && item.tipo == 1
          )
        : null;
      vm.form.trenIda.horario = vm.modalItem.idTrenEstacionIn
        ? vm.containers.trenes.find(
            item =>
              item.idTrenEstacion == vm.modalItem.idTrenEstacionIn &&
              item.tipo == 1
          )
        : null;
      // tren retorno
      vm.form.trenRetorno.servicio = vm.modalItem.idTrenServicioOut
        ? vm.containers.trenes.find(
            item =>
              item.idTrenServicio == vm.modalItem.idTrenServicioOut &&
              item.tipo == 2
          )
        : null;
      vm.form.trenRetorno.numero = vm.modalItem.idTrenOut
        ? vm.containers.trenes.find(
            item => item.idTren == vm.modalItem.idTrenOut && item.tipo == 2
          )
        : null;
      vm.form.trenRetorno.horario = vm.modalItem.idTrenEstacionOut
        ? vm.containers.trenes.find(
            item =>
              item.idTrenEstacion == vm.modalItem.idTrenEstacionOut &&
              item.tipo == 2
          )
        : null;

      // machupicchu
      // vm.form.machuPicchu.tipo = vm.modalItem.idServicioTipo;
      vm.form.machuPicchu.horaTicket = vm.$options.filters.date(
        vm.modalItem.horaTicket,
        "HH:mm:ss",
        "HH:mm"
      );
      vm.form.machuPicchu.almuerzo = vm.modalItem.idRestaurante ? true : false;
      vm.form.machuPicchu.restaurante = vm.modalItem.idRestaurante
        ? vm.containers.restaurantes.find(
            item => item.idRestaurante == vm.modalItem.idRestaurante
          )
        : null;
      vm.form.machuPicchu.overnight = vm.modalItem.idHotelOvernight
        ? true
        : false;
      vm.form.machuPicchu.hotel = vm.modalItem.idHotelOvernight
        ? vm.containers.hoteles.find(
            item => item.idHotel == vm.modalItem.idHotelOvernight
          )
        : null;
      vm.form.machuPicchu.huaynaPicchu = vm.modalItem.horaHuayna ? true : false;
      vm.form.machuPicchu.huaynaPicchuHora = vm.$options.filters.date(
        vm.modalItem.horaHuayna,
        "HH:mm:ss",
        "HH:mm"
      );

      vm.fetchServicioTipos(vm.modalItem.idServicioTipo);

      // traslados
      vm.form.traslado.origen = vm.modalItem.idOrigen
        ? vm.containers.puntos.find(
            item => item.idPuntoTraslado == vm.modalItem.idOrigen
          )
        : null;
      vm.form.traslado.destino = vm.modalItem.idDestino
        ? vm.containers.puntos.find(
            item => item.idPuntoTraslado == vm.modalItem.idDestino
          )
        : null;
    }

    vm.$nextTick(() => {
      // DOM updated
      vm.$watch("form.trenIda.servicio", (val, old) => {
        vm.form.trenIda.numero = null;
      });
      vm.$watch("form.trenIda.numero", (val, old) => {
        vm.form.trenIda.horario = null;
      });
      vm.$watch("form.trenRetorno.servicio", (val, old) => {
        vm.form.trenRetorno.numero = null;
      });
      vm.$watch("form.trenRetorno.numero", (val, old) => {
        vm.form.trenRetorno.horario = null;
      });

      vm.$watch("form.vehiculo", (val, old) => {
        if (val?.idVehiculo !== 0 && val?.idConductor) {
          vm.form.conductor = vm.containers.conductores.find(
            item => item.idPersona == val.idConductor
          );
        } else {
          vm.form.conductor = null;
          vm.form.otroVehiculo = "";
        }
      });

      vm.$watch("form.servicio", (val, old) => {
        if (vm.showMachuPicchuOpciones) {
          vm.fetchServicioTipos();
        }
      });
    });

    vm.loading.view = false;
  },
  methods: {
    async fetchServicioTipos(idServicioTipo = null) {
      const vm = this;
      vm.loading.machuPicchu = true;
      try {
        const response = await vm.axios.get(
          `/servicios/${vm.form.servicio.idServicio}/tipos`
        );
        vm.containers.tipos = response.data.content;

        if (idServicioTipo) {
          vm.form.machuPicchu.tipo = vm.containers.tipos.find(
            item => item.idServicioTipo == idServicioTipo
          );
        }

        vm.loading.machuPicchu = false;
      } catch (error) {
        console.error({ error });
      }
    },
    async onSave() {
      const vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) return;

      let fd = {
        servicio: vm.form.servicio.idServicio,
        fecha: vm.form.fecha,
        idioma: vm.form.idioma.idIdioma,
        file: String(vm.form.file || "").trim() || null,
        horaRecojo: String(vm.form.horaRecojo || "").trim() || null,
        horaInicio: String(vm.form.horaInicio || "").trim() || null,
        nombrePax: String(vm.form.nombre || "").trim(),
        paxAdultos: vm.form.PAX,
        paxNinos: vm.form.CHD,
        servicioIn: vm.form.trenIda.servicio?.idTrenServicio || null,
        numeroTrenIn: vm.form.trenIda.numero?.idTren || null,
        idHorarioIn: vm.form.trenIda.horario?.idTrenEstacion || null,
        servicioOut: vm.form.trenRetorno.servicio?.idTrenServicio || null,
        numeroTrenOut: vm.form.trenRetorno.servicio?.idTrenServicio || null,
        idHorarioOut: vm.form.trenRetorno.servicio?.idTrenServicio || null,
        hotel: vm.form.hotel?.idHotel || null,
        agencia: vm.form.agencia?.idAgencia || null,
        movil: vm.form.vehiculo?.idVehiculo || null,
        movilOtro: String(vm.form.otroVehiculo || "").trim() || null,
        conductor: vm.form.conductor?.idPersona || null,
        otroConductor: String(vm.form.otroConductor || "").trim() || null,
        guia: vm.form.guia?.idPersona || null,
        transfer: vm.form.transfer?.idPersona,
        observaciones: String(vm.form.observaciones || "").trim(),
        machuPicchuTipo: vm.form.machuPicchu.tipo?.idServicioTipo || null,
        machuPicchuHoraTicket: vm.form.machuPicchu.horaTicket,
        machuPicchuAlmuerzo: vm.form.machuPicchu.almuerzo ? 1 : 0,
        machuPicchuAlmuerzoRestaurante:
          vm.form.machuPicchu.restaurante?.idRestaurante,
        machuPicchuOvernight: vm.form.machuPicchu.overnight ? 1 : 0,
        machuPicchuOvernightHotel: vm.form.machuPicchu.hotel?.idHotel || null,
        machuPicchuHuaynaPicchu: vm.form.machuPicchu.huaynaPicchu ? 1 : 0,
        machuPicchuHuaynaPicchuHoraTicket: vm.form.machuPicchu.huaynaPicchuHora,
        trasladoOrigen: vm.form.traslado.origen?.idPuntoTraslado || null,
        trasladoDestino: vm.form.traslado.destino?.idPuntoTraslado || null
      };

      vm.loading.save = true;

      let endpoint = vm.modalItem
        ? vm.axios.put(`/endosados/${vm.modalItem.idEndose}`, fd)
        : vm.axios.post("/endosados", fd);

      try {
        const response = await endpoint;
        vm.$toast.fire({
          title: response.data.content.message,
          icon: "success"
        });
        vm.$emit("save");
      } catch (error) {
      } finally {
        vm.loading.save = false;
      }
    }
  }
};
</script>
